import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues, SubmissionError } from 'redux-form'
import { Button, Breadcrumb, Icon } from 'semantic-ui-react'

import RequestInfo from '../Shareds/RequestInfo'
import GeneralInfo from '../Shareds/GeneralInfo'
import POItemInfo from '../Shareds/POItemInfo'
import DocumentStep from 'routes/ProcurementSystem/Shared/DocumentStep'
import ActionCommentModal from '../Shareds/ActionCommentModal'
import Attachment from '../Shareds/Attachment'
import CommentHistory from './CommentHistory'
import Approve from '../Shareds/Approve'
import { scrollToFirstValidateFailElement } from 'core/utilities'
import { getSpecialApproval, getProjectByCompany } from 'ducks/goa'
import { purchaseOrderUpdatePath } from 'routes'
import {
  validateField,
} from '../helper'
import { 
  MainBodyContent, 
} from 'components'
import { 
  initializePOUpdate,
  fetchPOComplete,
  getPOUpdateDetail,
  getPOUGOAWorkFlowViewMode,
  actionPOUpdate,
  getPOCompleteDetail,
  clearPOUpdateData
} from 'ducks/poUpdate'
import r from 'reactotron-react-js'

import { BottomActionsContainer } from './styled'

const DetailPOUpdate = props => {

  const { 
    history,
    valueForm,
    pouDetail,
    change,
    poComplete,
    isDetail = true,
  } = props

  const [actionName, setActionName] = React.useState('')
  const [showDialogComment,setShowDialogComment] = React.useState(false)

  React.useEffect(() => {
    const { match } = props
    window.scrollTo(0,0)
    props.initializePOUpdate(isDetail)
    if (match && match.params && match.params.pouId) {
      props.getPOUpdateDetail(match.params.pouId, history,false,'Detail')
    }
    return(()=>{
      props.clearPOUpdateData()
    })
  },[])

  React.useEffect(() => {
    if(valueForm&&valueForm.poSelect){
      let po = poComplete.data.find(x=>x.poSapNumber == valueForm.poSelect)
      if(po){
        change('companyName',`${po.companyCode} | ${po.companyName}`)
        // change('projectName',po.projectName)
        change('poId',po.poId)
        change('purchaseOrderNumber',po.poSapNumber)
        if(props.pouDetail.data.purchaseOrderNumber != valueForm.poSelect){
          change('purchaseGroupCode',po.purchGroup)
        }
        props.getPOUGOAWorkFlowViewMode(valueForm.id)
        props.getPOCompleteDetail(po.poSapNumber,'Detail')
      }
    }
  },[(valueForm&&valueForm.poSelect),poComplete.data])

  React.useEffect(()=>{
    if(valueForm&&valueForm.projectId){
      props.getSpecialApproval(valueForm.projectId)
    }
  },[(valueForm&&valueForm.projectId)])

  React.useEffect(()=>{
    if(valueForm&&valueForm.companyCode){
      props.getProjectByCompany(valueForm.companyCode)
    }
  },[(valueForm&&valueForm.companyCode)])

  const onSubmitForm = () => {
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
    return sleep(100)
    .then(() => {
      let errors = validateField(valueForm)
      if(Object.keys(errors).length){
        scrollToFirstValidateFailElement(errors)
        throw new SubmissionError(errors)
      }else{
        if(actionName=='cancel'){
          props.actionPOUpdate({
            docId: valueForm.id,
            sn: valueForm.sn,
            action: 'cencel',
            comment: valueForm.actionComment,
          }, history)
        }
      }
    })
  } 

  return (
    <MainBodyContent
      headerTitle={<React.Fragment>{valueForm&&valueForm.isSpecialCreditTerm&&<Icon size='tiny' name='star' color='yellow'/>}{`Update/Cancel PO ${pouDetail.data?pouDetail.data.documentNumber?`- #${pouDetail.data.documentNumber}`:'':''}`}</React.Fragment>}
      breadcrumbs={
        <Breadcrumb
          icon="right angle"
          sections={[
            {
              key: 'pou',
              content: 'Update/Cancel PO',
              link: true,
              onClick: () => history.push(purchaseOrderUpdatePath),
            },
            { key: 'pouDetail', content: 'Detail', active: true },
          ]}
        />
      }
    >
      {valueForm&&<DocumentStep documentDetail={valueForm} approvers={props.goaWorkFlow.data} />}
      <RequestInfo isDetail/>

      {valueForm&&(valueForm.sn&&valueForm.status!=6)?
      <Approve history={history} handleSubmit={props.handleSubmit} data={pouDetail.data}/>:null}

      <GeneralInfo isDetail history={history}/>

      {valueForm&&valueForm.poSelect&&
      <POItemInfo/>}

      <CommentHistory/>

      <Attachment/>

      {/* {valueForm&&valueForm.status==5&&valueForm.requesterUser==&&
        <form onSubmit={props.handleSubmit(()=>onSubmitForm())}>
        <BottomActionsContainer>
          <Button 
            type='button'
            content='Cancel' 
            color='red' 
            style={{ marginRight: '0.3125rem' }}
            onClick={()=>{
              setShowDialogComment(true)
              setActionName('cancel')
            }}
          />
        </BottomActionsContainer>
      </form>} */}
      {/* {showDialogComment&&<ActionCommentModal submit={props.handleSubmit(()=>onSubmitForm())} setShowDialogComment={setShowDialogComment} actionName={actionName}/>} */}
    </MainBodyContent>
  )

}

const mapStateToProps = (state) => {
  let pouDetail = state.poUpdate.pouDetail
  return ({
    initialValues: {
      ...pouDetail.data,
      poSelect:pouDetail.data.purchaseOrderNumber,
    },
    goaWorkFlow: state.poUpdate.goaWorkFlow,
    pouDetail,
    poComplete: state.poUpdate.poComplete,
    valueForm: getFormValues('formPOUpdate')(state),
  })
}
const mapDispatchToProps = {
  initializePOUpdate,
  fetchPOComplete,
  getPOUpdateDetail,
  getPOUGOAWorkFlowViewMode,
  getPOCompleteDetail,
  actionPOUpdate,
  clearPOUpdateData,
  getSpecialApproval, 
  getProjectByCompany
}

const contForm = reduxForm({
  form: 'formPOUpdate',
  enableReinitialize: true,
})(DetailPOUpdate)

export default connect(mapStateToProps, mapDispatchToProps)(contForm)
